// Supported content languages (ISO 639-1)
export enum Language {
    en = "en",          // English
    da = "da",          // Danish
    no = "no",          // Norwegian
    sv = "sv",          // Swedish
    de = "de",          // German
    es = "es",          // Spanish
    fr = "fr",          // French
    it = "it",          // Italian
    nl = "nl",          // Holland
    ro = "ro",          // Romanian
}

export class LanguageOption {
    code: Language | string;
    label: string;
    labelEn: string;
    emoji: string;
    priority: number;
    webflowId: string;
}

// Tour languages
export const LanguageMap: { [language in Language]: LanguageOption } = {
    'en': { code: Language.en, label: 'English', labelEn: 'English', emoji: '🇬🇧', priority: 0, webflowId: '6537eed8f87d08bc57f28394' },
    'da': { code: Language.da, label: 'Dansk', labelEn: 'Danish', emoji: '🇩🇰', priority: 1, webflowId: '6537eee3b663536f72ab6ac2' },
    'de': { code: Language.de, label: 'Deutsch', labelEn: 'German', emoji: '🇩🇪', priority: 2, webflowId: '655085144d1a59b887734a11' },
    'es': { code: Language.es, label: 'Español', labelEn: 'Spanish', emoji: '🇪🇸', priority: 3, webflowId: '65508557f224407ac9c2f797' },
    'sv': { code: Language.sv, label: 'Svenska', labelEn: 'Swedish', emoji: '🇸🇪', priority: 4, webflowId: '6550853f746087a0081de4ed' },
    'no': { code: Language.no, label: 'Norsk', labelEn: 'Norwegian', emoji: '🇳🇴', priority: 5, webflowId: '667bf8cf6c2bc5f9ddc384e2' },
    'fr': { code: Language.fr, label: 'Français', labelEn: 'French', emoji: '🇫🇷', priority: 6, webflowId: '6572e6736221e2b26a998348' },
    'it': { code: Language.it, label: 'Italiano', labelEn: 'Italian', emoji: '🇮🇹', priority: 7, webflowId: '65508527de2293e054d45f12' },
    'nl': { code: Language.nl, label: 'Nederlands', labelEn: 'Dutch', emoji: '🇳🇱', priority: 8, webflowId: '6819d4700b28e19a5105ab06' },
    'ro': { code: Language.ro, label: 'Română', labelEn: 'Romanian', emoji: '🇷🇴', priority: 9, webflowId: '69e8e84eb1cdfb1d89f7870c' },

};

export const LanguageList: LanguageOption[] = Object.keys(LanguageMap).map(code => LanguageMap[code]);

/**
 * @deprecated: Use Language enum instead of TourLanguage
 * */
export type TourLanguage = Language;

// Map tour language to supported app languages
export const TourToAppLanguageMap: { [tourLanguage in Language]: Language } = {
    'da': Language.da,
    'sv': Language.en,
    'no': Language.en,
    'en': Language.en,
    'de': Language.en,
    'es': Language.en,
    'fr': Language.en,
    'it': Language.en,
    'nl': Language.en,
    'ro': Language.en,
}

// Languages supported by i18n integration
export enum SupportedLanguage {
    da = "da",          // Danish
    en = "en",          // English
}

// Supported locale translations in home / tours.storyhunt.io, used for SSR
export const HOME_SUPPORTED_LOCALES = ['en', 'da'];

/** Webflow marketing-site tour page locales (www.storyhunt.io). */
export const WEBFLOW_TOUR_LOCALES = {
    en: { cmsLocale: 'en', baseUrl: 'https://www.storyhunt.io/en/walkingtours/' },
    da: { cmsLocale: 'da', baseUrl: 'https://www.storyhunt.io/da/gaature/' },
    de: { cmsLocale: 'de', baseUrl: 'https://www.storyhunt.io/de/audiotouren/' },
} as const;

export type WebflowTourLocale = keyof typeof WEBFLOW_TOUR_LOCALES;

export function isWebflowTourLocale(language: string): language is WebflowTourLocale {
    return language?.toLowerCase() in WEBFLOW_TOUR_LOCALES;
}

/** Map tour language to Webflow CMS locale for share links and API calls. */
export function webflowLocaleForTourLanguage(language: string): WebflowTourLocale {
    const code = language?.toLowerCase();
    if (isWebflowTourLocale(code)) return code;
    return 'en';
}
